import React from 'react';
import { feedbackV2 } from '@ecosystem/newron-design-system';
import { GenericWarning } from '../../types';

const { Alert } = feedbackV2;

type GenericWarningsProps = {
  warnings?: GenericWarning[];
  className?: string;
};

export default function GenericWarnings({ warnings = [], className = 'mb-4' }: GenericWarningsProps) {
  return (
    <>
      {warnings.map((warning, index) => (
        <div className={className} key={index}>
          <Alert key={warning.message} title={warning.message} type={warning.level} />
        </div>
      ))}
    </>
  );
}
